"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGION_NOT_WORKING = exports.HttpStatusCode = void 0;
var http_status_codes_1 = __importDefault(require("http-status-codes"));
exports.HttpStatusCode = http_status_codes_1.default;
exports.REGION_NOT_WORKING = 'Region is not working';
//# sourceMappingURL=Enums.js.map